import React from 'react';
import { Outlet } from 'react-router-dom';
import KnowledgeBaseHeader from './KnowledgeBaseHeader';
import MoveToTop from '../MoveTotop/MoveToTop';
import Footer from '../Footer/Footer';

function KnowledgeBaseLayout() {
  return (
    <div>
      <KnowledgeBaseHeader />
      <div className="contents"><Outlet /></div>
      <Footer />
      <MoveToTop />
    </div>
  );
}

export default KnowledgeBaseLayout;
